// extracted by mini-css-extract-plugin
export default {"container":"rN1r2M4uyLLxTinlBRP5"};